import { Toaster } from '@/components/atomic/molecules';

// TODO: successToast -> toastType & use TOAST_TYPE when we have to support 2+ types - create dictionary, even for iconSrc
// const TOAST_TYPE = {
//   ERROR: 'ERROR',
//   SUCCESS: 'SUCCESS',
//   WARNING: 'WARNING'
// }
const ToastContainerOrganism = ({ setShowToast, showToast }) => {
  const { message, position, show, successToast } = showToast;
  return (
    show && (
      <div className='flex justify-center items-end mx-auto gap-4'>
        <Toaster
          {...{
            iconSrc: successToast ? 'checked-green.svg' : 'failed.svg',
            message,
            position,
            setShowToast,
            showIcon: true
          }}
        />
      </div>
    )
  );
};

export default ToastContainerOrganism;
